import React from 'react';

import Icon from '@ant-design/icons';
import { EPanelOpenMethod } from '@components/block-event-single/store';
import { MappingRuleTitle } from '@components/detail-panel/components/EventMappingRules/styled';
import { IMappingRulesExplorer } from '@components/detail-panel/components/EventMappingRules/typed';
import HyperlinkIcon from '@icons/event-management/hyperlink.svg';
import PermissionButton from '@src/emp-3.0/components/PermissionButton';

const MappingRulesExplorer: React.FC<IMappingRulesExplorer> = ({
  readOnly,
  mode,
  title,
  buttonText,
  onClick,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: '28px',
        marginBottom: '4px',
      }}
    >
      <MappingRuleTitle>{title}</MappingRuleTitle>
      <PermissionButton
        style={{ border: 'none', fontWeight: 400, fontSize: '12px' }}
        onClick={onClick}
        styleType="styled"
      >
        {buttonText && mode === EPanelOpenMethod.VIEW && !readOnly && (
          <>
            {buttonText}
            <Icon component={HyperlinkIcon} />
          </>
        )}
      </PermissionButton>
    </div>
  );
};

export default MappingRulesExplorer;
